import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
let AIQuizGenerationTextField = class AIQuizGenerationTextField extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "disabled", void 0);
    _defineProperty(this, "placeholder", void 0);
    _defineProperty(this, "fieldType", 'textarea');
    _defineProperty(this, "textContent", '');
  }
  onContentChange(content) {
    this.textContent = content;
    this.emitContent();
  }
  emitContent() {
    return this.textContent;
  }
};
__decorate([Prop({
  default: false
})], AIQuizGenerationTextField.prototype, "disabled", void 0);
__decorate([Prop({
  default: ''
})], AIQuizGenerationTextField.prototype, "placeholder", void 0);
__decorate([Emit('contentChange')], AIQuizGenerationTextField.prototype, "emitContent", null);
AIQuizGenerationTextField = __decorate([Component({
  components: {
    WInput
  }
})], AIQuizGenerationTextField);
export default AIQuizGenerationTextField;